YP.EventStoreWorkshop = function() {
    const maxWorkshopSession = 50;
    var showMoreFilters = $('.js-workshop_show-more-filters');
    var showFilters = $(".js-workshop__show-filters");
    return {
        addSessionClick: function(e) {
            e.preventDefault();
            YP.EventStoreWorkshop().updateWorkshopForm();
        },
        init: function(){

            showMoreFilters.on('click', function (e) {
                var showFilterIcon = $(this).find('i');
                e.preventDefault();
                showFilters.toggle();
                showFilterIcon.toggleClass("fa-chevron-up fa-chevron-down");
                if (showFilterIcon.hasClass("fa-chevron-up")) {
                    $('.js-orders_change-word:contains("plus")').text("moins");
                } else {
                    $('.js-orders_change-word:contains("moins")').text("plus");
                }
            });

            if($('#workshop-form').length) {
                $('.js-add-session').bind('click', YP.EventStoreWorkshop().addSessionClick);
                $('.remove-session').live('click', function(e) {
                    e.preventDefault();
                    const countWorkshopSession = $('#workshop_session_form .js-table-form-row').filter((_, e) => {
                        return $(e).css('display') !== 'none';
                    }).length - 1;                    
                    if (countWorkshopSession <= 1) {
                        return;
                    }                    
                    if ($(this).data('is-new-session') == 1) {
                        $(this).parentsUntil('.c-table__body').remove();
                    } else {
                        $(this).parentsUntil('.c-table__body').attr('style', 'display:none');
                    }
                    if ($(this).data('is-duplicate') == 1) {
                        $(`input[name="workshop[sessions][${$(this).data('index')}][id]"]`).remove();
                        $(`input[name="workshop[sessions][${$(this).data('index')}][to_delete]"]`).remove();
                        $(`input[name="workshop[sessions][${$(this).data('index')}][TypeProductConstraintQuantity][id]"]`).remove();
                    }
                    $('#workshop_session_form .js-table-form-row').each(function(index) {
                        $(this).find('.js-table-form-cell.number').data('index', index);
                    });
                    $('#workshop_session_form .js-table-form-row').filter((_, e) => {
                        return $(e).css('display') !== 'none';
                    }).each(function(index) {
                        $(this).find('.js-table-form-cell.number').html(index);
                        if (countWorkshopSession === 2) {
                            $(this).find('.remove-session').prop('disabled', true);
                        }
                    });
                    $("#workshop_sessions_" + $(this).data("index") + "_to_delete").val("1");
                    $("#workshop_sessions_" + $(this).data("index") + "_TypeProductConstraintQuantity_id").hide()
                });
                if ($('#redactor_content_store').length > 0) {
                    $('#redactor_content_store').css('width', '100%').redactor({
                        focus: false,
                        toolbarFixed: false,
                        plugins: ['fontfamily', 'fontsize', 'fontcolor', 'backcolor', 'fullscreen'],
                        autoresize: false,
                        protocol: 'https://',
                        imageUpload: $('#redactor_content_store').data('url'),
                        imageUploadType: 'image'
                    });
                }

                $('select.js-workshop__type-ticket').select2({
                    formatNoMatches: function(){
                        return 'Aucun tarif';
                    },
                });

                function updateVATRateField() {
                    let hasPositiveAmount = false;
                    $('.js-session-amount').each(function () {
                        if (Number.parseFloat($(this).val()) > 0) {
                            hasPositiveAmount = true;
                        }
                    });
                    $('.js-workshop-vat-rate').prop('disabled', !hasPositiveAmount);
                    $('.vat-rate-div').hide();
                    if (hasPositiveAmount === true) {
                        $('.vat-rate-div').show();
                    }
                }

                $('#workshop_session_form').on('change', '.js-session-amount', updateVATRateField);
                updateVATRateField();
            }

            if($('.js-table-workshop').length) {
                $('.js-show-workshop-session').on('click', function(e) {
                    e.preventDefault();
                    workshopId = $(this).data('id');
                    $('.session-header[data-id=' + workshopId + ']').toggle();
                    $('.session-row[data-id=' + workshopId + ']').toggle();
                    $(this).parent().find('i').toggleClass("fa-chevron-down fa-chevron-up");
                });
                $('.switch-status').live('click', function(e){
                    e.preventDefault();
                    url = $(this).attr('href');
                    $icone = $(this).find('i');
                    $.ajax({
                        type: 'PUT',
                        url: url,
                        dataType: "json",
                        success: function(data) {
                            if(data.is_active === false) {
                                $icone.attr('class', 'fa fa-remove');
                            } else {
                                $icone.attr('class', 'fa fa-check');
                            }
                        }
                    });
                });
                YP.EventStoreWorkshop().initSortable();
            }

            if($('.js-calendar-change-date').length) {
                $(".js-calendar-change-date").on("change",YP.EventStoreWorkshop().updateDateWorkshopForm());
            }
        },
        updateWorkshopForm : function () {
            $form = $('#workshop-form');
            $index = $('#workshop_session_form .js-table-form-row').last().find('.js-table-form-cell.number').data('index');

            $('#workshop_session_form .js-table-form-row').each(function() {
                $(this).find('.remove-session').prop('disabled', false);
            });

            if($index < maxWorkshopSession) {
                $.ajax({
                    url: $form.attr('ajax-action') + '?index=' + $index,
                    type: "post",
                    data: $form.serialize(),
                    dataType: 'json',
                    success: (data) => {
                        if (data) {
                            $('#workshop_session_form table tbody').append(data.view);
                            $('#workshop_session_form .js-table-form-row').last().find('.js-table-form-cell.number').html($('#workshop_session_form .js-table-form-row').filter((_, e) => {
                                return $(e).css('display') !== 'none';
                            }).length - 1);
                            $('#workshop_session_form .js-table-form-row').last().find('.js-table-form-cell.number').data('index', $('#workshop_session_form .js-table-form-row').length - 1);
                            initDatePicker();
                        }
                    }
                }).done(() => {
                    $(".js-calendar-change-date").on("change",YP.EventStoreWorkshop().updateDateWorkshopForm());
                });
            }
        },
        updateDateWorkshopForm: function(){
            $('.js-calendar-change-date').on("change", function(e) {
                var parent   = $(this).parent('.js-table-form-cell').data("index");
                var begin     = $("#workshop_sessions_" + parent + "_begin_date");
                var end      = $("#workshop_sessions_" + parent + "_end_date");
                var beginVal = moment($(this).find(begin).val(), 'DD-MM-YYYY');
                var endVal   = moment(end.val(), 'DD-MM-YYYY');

                if (beginVal.unix() > endVal.unix()) {
                    end.val(begin.val());
                }
            });
        },
        initSortable: function(e) {
            $(".js-table-workshop tbody").sortable({
                handle: '.js-dragggable-row',
                placeholder: "c-table__body_highlight",
                helper: function(e, tr) {
                    var $originals = tr.children();
                    var $helper = tr.clone();
                    $helper.children().each(function(index) {
                        $(this).width($originals.eq(index).width());
                    });
                    return $helper;
                },
                start: function(event, ui) {
                    workshopId = ui.item.attr('id');
                    $('.session-header[data-id=' + workshopId + ']').hide();
                    $('.session-row[data-id=' + workshopId + ']').hide();
                    $('.js-workshop-row[data-id='+ workshopId +']').find('.js-show-workshop-session i').attr('class', 'fa fa-chevron-up');
                },
                update: function(event, ui) {
                    var order = $(".js-table-workshop tbody").sortable("toArray").filter(Number);
                    idItem = ui.item.attr('id');
                    $(".session-header[data-id="+ idItem +"]").detach().insertAfter(".js-workshop-row[data-id="+ idItem +"]");
                    $(".session-row[data-id="+ idItem +"]").detach().insertAfter(".session-header[data-id="+ idItem +"]");
                    $.post($('table.js-table-workshop').data('sorturl'), {
                        order: order
                    });
                }
            });
        }
    };
};

window.addEventListener("load", function(){
    YP.EventStoreWorkshop().init();
});
